import { Box, Button } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react'
import { ReactTable } from '@components';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table'
import { showToast } from '@utils'
import { apiBuyPriceProfile } from '@store';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const YearTwo = ({ singlePriceProfile, loading, call, put, volume }) => {
    const dispatch = useDispatch();
    const { uuid } = useParams();
    const [yearTwoTotalState, setYearTwoTotalState] = useState(0);
    const [yearTwoVolState, setYearTwoVolState] = useState(0);

    useEffect(() => {
        let tempYearTwoTotal = 0;
        let tempYearTwoVol = 0;

        for (let i in singlePriceProfile) {
            tempYearTwoVol += singlePriceProfile[i].Total;
            tempYearTwoTotal += singlePriceProfile[i].PriceTotal;
        }

        setYearTwoTotalState(tempYearTwoTotal);
        setYearTwoVolState(tempYearTwoVol);
    }, [singlePriceProfile]);

    const handleBuy = async (e) => {
        e.preventDefault();

        const year = singlePriceProfile ? singlePriceProfile[0].Year : 0;

        if (year === 0) {
            showToast('error', 'Year not found');
            return;
        }

        const data = {
            uuid: uuid,
            volume: parseFloat(volume),
            call: parseFloat(call),
            put: parseFloat(put),
            year: year
        }

        const resp = await dispatch(apiBuyPriceProfile(data));
        if (resp?.meta?.requestStatus === 'fulfilled') {
            showToast('success', 'Successfully bought the profile');
        } else if (resp?.meta?.requestStatus === 'rejected') {
            showToast('error', resp.payload);
        }
    }

    const columns = useMemo(
        () => [
            {
                header: "Month",
                id: "MonthStr",
                accessorFn: ({ MonthStr }) => MonthStr || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: "Year",
                id: "Year",
                accessorFn: ({ Year }) => Year || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: (
                    <Box className='flex flex-col'>
                        <Box>Total Vol</Box>
                        <Box>[MWh]</Box>
                    </Box>
                ),
                id: "TotalStr",
                accessorFn: ({ TotalStr }) => TotalStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: "Hours/Month",
                id: "MonthHours",
                accessorFn: ({ MonthHours }) => MonthHours || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: "MWh/h",
                id: "TotalMWStr",
                accessorFn: ({ TotalMWStr }) => TotalMWStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: "Price",
                id: "AskPriceStr",
                accessorFn: ({ AskPriceStr }) => AskPriceStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: "Flex Price",
                id: "FlexPriceStr",
                accessorFn: ({ FlexPriceStr }) => FlexPriceStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: (
                    <Box className='flex flex-col'>
                        <Box>Min Take</Box>
                        <Box>[MWh/h]</Box>
                    </Box>
                ),
                id: "MinTakeStr",
                accessorFn: ({ MinTakeStr }) => MinTakeStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: (
                    <Box className='flex flex-col'>
                        <Box>Max Take</Box>
                        <Box>[MWh/h]</Box>
                    </Box>
                ),
                id: "MaxTakeStr",
                accessorFn: ({ MaxTakeStr }) => MaxTakeStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: "Cost [EUR]",
                id: "PriceTotalStr",
                accessorFn: ({ PriceTotalStr }) => PriceTotalStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "",
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50,
                Footer: () =>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1
                        }}
                    >
                        <Box
                            fontSize={18}
                            display={'flex'}
                            alignItems={'center'}
                            gap={1}
                        >
                            Avg Price:
                            <span
                                className='text-green-700'
                            >
                                {(yearTwoTotalState / yearTwoVolState).toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                        </Box>
                        <Button
                            variant='outlined'
                            color='primary'
                            sx={{
                                p: 0,
                                m: 0,
                                backgroundColor: '#27A9FF',
                                border: '1px solid #27A9FF',
                                color: '#fff',
                                fontSize: '13px',
                                '&:hover': {
                                    color: 'white',
                                    backgroundColor: '#27A9FF',
                                    border: '1px solid #27A9FF',
                                },
                            }}
                            onClick={handleBuy}
                        >
                            Buy
                        </Button>
                    </Box>,
            },
        ], [yearTwoTotalState, yearTwoVolState]
    );

    return (
        <ReactTable
            renderToolbarInternalActions={
                ({ table }) => (
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <MRT_ToggleGlobalFilterButton table={table} />
                    </div>
                )
            }
            headerText={'Year Two'}
            columns={columns}
            data={singlePriceProfile || []}
            isLoading={loading}
        />
    )
}

export default YearTwo